import React from 'react';
import styled from 'styled-components';
import { CSVLink } from "react-csv";
import arrowRight from '../assets/arrow-right.svg';
import arrowLeft from '../assets/arrow-left.svg';
import play from '../assets/play.svg';
import noVid from '../assets/no-video.svg';
import loader from '../assets/loader.svg';
import smallLoader from '../assets/loader-small.svg';
import Modal from './modal/Modal';
import Video from './VideoPlayer/Video';
import moment from 'moment';
import {baseUrl} from './url';
import { Redirect } from 'react-router-dom';


const ExportContainer = styled.div`
  padding: 20px;
  background: #FFFFFF;
  -webkit-box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  border-radius: 0 0 3px 3px;
  border-top: 4px solid #14DA9E;
  margin: 40px 0;
`;
const ExportButton = styled.button`
    width: 75%;
    font-size: 14px;
    color: #FFFFFF;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #7C74FE;
    border: 2px dashed #6C63FF;
    box-sizing: border-box;
    border-radius: 3px;
    height: 36px;
    margin-top: 20.4px;
    display: flex;
    justify-content: center;
    margin: 14px auto;
`;

const prettyCSVButton = {
  width: "100%",
  color: "#FFFFFF",
  height: "100%",
  display: "flex",
  marginLeft: "12%",
  textDecoration: 'none'
}




class Reviews extends React.Component{
    constructor(){
        super()
        this.state = {
            thisMonth: moment().format('YYYY-MM'),
            currentDate: moment().format('YYYY-MM-DD'),
            days: 7,
            vots: {},
            response: false,
            show: false,
            loadMore: true,
            startOfMonth: false,
            view: 'today',
            csvData: [],
        }
        this.incrementMonth = this.incrementMonth.bind(this);
        this.decrementMonth = this.decrementMonth.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.fetchVots = this.fetchVots.bind(this);
        this.handleLoadmore = this.handleLoadmore.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.handleView = this.handleView.bind(this);
    }
    componentWillMount(){
        this.fetchVots()
    }
    fetchVots(){
        let days = this.state.days - 1;
        let currentDate = this.state.currentDate;
        let endDate = '';
        if(this.state.view === "week"){
            let startOfWeek = moment().startOf('week');
            let currDate = moment();
            let diff = currDate.diff(startOfWeek, 'days');
            days = diff - 1;
            endDate = moment(currentDate).subtract({days}, 'days').format('YYYY-MM-DD');
            this.setState({
                response: false
            })
        }else if(this.state.view === "today"){
            endDate = moment(currentDate).subtract(0, 'days').format('YYYY-MM-DD');
            this.setState({
                response: false
            })
        }else{
            endDate = moment(currentDate).subtract({days}, 'days').format('YYYY-MM-DD');
        }

        let retries = 0;
        const token = localStorage.getItem('access_token');
        const url = `${baseUrl}/admin/vots?end_date=${currentDate}&start_date=${endDate}`;
        fetch(url,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            if(response.status === 403){
                localStorage.removeItem('access_token');
                return <Redirect to='/login' />
            }
            return response.json();
        })
        .then((responseJson) => {
          let csvData = []

          Object.keys(responseJson.data).reverse().forEach(function(key, index){
              let vots = responseJson.data[key]

              csvData.push([key])
              vots.forEach(vot => {
                csvData.push(['Patient Name', vot.patient_name])
                csvData.push(['Video URL', vot.video_url])
                csvData.push(['Date Received', vot.date_received])
              })
          })

            this.setState({
                vots: responseJson.data,
                response: true,
                loadMore: true,
                csvData: csvData
            })
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    incrementMonth(){
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.add(1, 'month').endOf('month');
            if(lastMonth > moment()){
                lastMonth = moment();
            }

        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false
        },this.fetchVots);
    }
    decrementMonth(){
        let thisMonth =  this.state.thisMonth,
            today = moment(thisMonth),
            lastMonth = today.subtract(1, 'month').endOf('month');
        this.setState({
            currentDate: lastMonth.format('YYYY-MM-DD'),
            thisMonth: lastMonth.format('YYYY-MM'),
            response: false,
            days: 7,
            startOfMonth: false
        },this.fetchVots);
    }
    handleLoadmore(){
        let days = this.state.days
        days = days + 7;
        let thisMonth =  this.state.thisMonth;
        let startOfMonth = moment(thisMonth).startOf('month');
        let daysInMonth = moment(thisMonth).daysInMonth();
        let currDate = moment();
        let dateToTest = moment(startOfMonth);
        let diff = currDate.diff(dateToTest, 'days');
        let monthStart;

        if(moment().format('YYYY-MM') === thisMonth && days >= diff){
            days = diff + 1;
            monthStart = true;
        }else if(moment().format('YYYY-MM') !== thisMonth && days >= daysInMonth){
            days = daysInMonth;
            monthStart = true;
        }
        this.setState({
            days: days,
            loadMore: false,
            startOfMonth: monthStart
        },this.fetchVots)
    }
    handleChange(e){
        this.setState({
            thisMonth: e.target.value
        })
    }
    showModal(id){
        this.setState({ videoId: id, show: true });
    }
    hideModal(){
        this.setState({ show: false });
    }
    handleView(e){
        if(e.target.name === 'all'){
            this.setState({
                response: false
            })
        }
        if(e.target.view !== 'all'){
            this.setState({
                currentDate: moment().format('YYYY-MM-DD')
            })
        }
        this.setState({
            view: e.target.name
        },this.fetchVots)
    }

    render(){
        let allVots = this.state.vots

        return(
            <div className="vot-reviews">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-9">
                            <div className="vot-submissions">
                                <div className="top">
                                    <div>
                                        <button className={`button today ${this.state.view === 'today' && 'active'}`}
                                                name="today"
                                                onClick={this.handleView}>
                                            Today
                                        </button>
                                        <button className={`button week ${this.state.view === 'week' && 'active'}`}
                                                name="week"
                                                onClick={this.handleView}>
                                            This week
                                        </button>
                                        <button className={`button all ${this.state.view === 'all' && 'active'}`}
                                                name="all"
                                                onClick={this.handleView}>
                                            All
                                        </button>
                                    </div>
                                    {
                                        this.state.view === 'all' &&
                                        <div>
                                            <button className="button"
                                                    onClick={this.decrementMonth}>
                                                <img src={arrowLeft} alt=""/>
                                            </button>
                                            <input type="month" name="bdaymonth" value={this.state.thisMonth} onChange={this.handleChange}/>
                                            <button className="button"
                                                    onClick={this.incrementMonth}
                                                    disabled={moment().format('YYYY-MM') === this.state.thisMonth && true}>
                                                <img src={arrowRight} alt=""/>
                                            </button>
                                        </div>
                                    }
                                </div>
                                {
                                    !this.state.response &&
                                    (
                                        <div className="loader">
                                            <img src={loader} alt=""/>
                                        </div>
                                    )
                                }
                                {
                                    this.state.response &&
                                    (Object.keys(allVots).reverse().map(function(key, index){
                                        let date = moment(key).format('dddd DD/MM/YYYY')
                                        let vots = allVots[key]

                                        return(
                                        vots.length === 0?
                                        <div className="vot-card" key={index}>
                                            <div className="title-head">{date} <span>{vots.length} VOT Submissions</span></div>
                                        </div>
                                        :
                                        <div className="vot-card" key={index}>
                                            <div className="title-head">{date} <span>{vots.length} VOT Submissions</span></div>
                                            <div className="vot-body">
                                                <table>
                                                  <tbody>
                                                      <tr>
                                                            <th></th>
                                                            <th>Patient Name</th>
                                                            <th>Time Received</th>
                                                            <th>Approval Status</th>
                                                            <th></th>
                                                        </tr>
                                                        {
                                                            vots.reverse().map(function(vot){
                                                                let votDate = moment(vot.date_received).format('h:mmA');
                                                                let caregiverApproval = vot.caregiver_status;
                                                                let approvalClass = "";
                                                                caregiverApproval === "unapproved" && (approvalClass = "dis-approved")
                                                                caregiverApproval === "approved" && (approvalClass = "approved")
                                                                caregiverApproval === "action_required" && (approvalClass = "pending")
                                                                const { video_url } = vot;
                                                                return(
                                                                    <tr key={vot.vot_id}>
                                                                        <td>
                                                                            {video_url && <div className="play-div"><img src={play} alt="" onClick={() => this.showModal(vot.vot_id)}/></div>}
                                                                            {!video_url && <img src={noVid} alt="" onClick={() => this.showModal(vot.vot_id)}/>}
                                                                        </td>
                                                                        <td><p>{vot.patient_name} <span>{vot.patient_alias}</span></p></td>
                                                                        <td className="date-time"><p>{votDate}</p></td>
                                                                        <td className={approvalClass}>
                                                                            <p>
                                                                                {caregiverApproval === "approved" && <i className="fa fa-check"></i>}
                                                                                {caregiverApproval === "unapproved" && <i className="fa fa-times"></i> }
                                                                                {caregiverApproval === "action_required" && <i className="fa fa-minus"></i>}
                                                                                {caregiverApproval === "action_required"? "Pending" : caregiverApproval}
                                                                            </p>
                                                                        </td>
                                                                        <td><button className="btn btn-view-history" onClick={() => this.showModal(vot.vot_id)}>View submission</button></td>
                                                                    </tr>
                                                                )
                                                            }.bind(this))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>)
                                    }.bind(this))
                                    )
                                }

                                <Modal show={this.state.show} handleClose={this.hideModal}>
                                    {this.state.show && <Video videoId={this.state.videoId}/>}
                                </Modal>
                                {
                                    Object.keys(allVots).length > 0 && this.state.response && this.state.loadMore && !this.state.startOfMonth && this.state.view === 'all' &&
                                    <p className="more-text" onClick={this.handleLoadmore}><i className="fa fa-plus-circle"></i>Load more submissions</p>
                                }
                                {
                                    !this.state.loadMore &&
                                    <div className="small-loader">
                                        <img src={smallLoader} alt=""/>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-3">
                            <div className="total-submissions">
                                <p>This Month</p>
                                <h6><span className="blue">{allVots.length || 0}</span>vDOT Submissions</h6>
                                <h6><span className="green">80</span>Approved</h6>
                                <h6><span className="red">2</span>Rejected</h6>
                            </div>


                            <ExportContainer>
                                <h6>Export Submissions</h6>
                                <ExportButton>
                                  <i className="fa fa-download"></i>

                                  <CSVLink
                                    data={this.state.csvData}
                                    filename={"submissions_report.csv"}
                                    style={prettyCSVButton}
                                    >
                                    Export submissions
                                  </CSVLink>
                                </ExportButton>
                            </ExportContainer>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/components/Reviews.js